import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UtilService } from '../../services/util';
import { SocialSharing } from '@ionic-native/social-sharing';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';


@IonicPage()
@Component({
  selector: 'page-how-it-works',
  templateUrl: 'how-it-works.html',
})
export class HowItWorksPage {
dispapp:any

  data = [
    {
      title: 'APP_TOUR.OVERVIEW.TITLE',
      body: 'APP_TOUR.OVERVIEW.BODY',
      link: 'https://www.youtube-nocookie.com/embed/SbB-KWjkmqQ',
    },
    {
      title: 'APP_TOUR.LOGIN.TITLE',
      body: 'APP_TOUR.LOGIN.BODY',
      link: 'https://www.youtube-nocookie.com/embed/LJvw6zHM2Pw',
    },
    {
      title: 'APP_TOUR.PAY_BILL.TITLE',
      body: 'APP_TOUR.PAY_BILL.BODY',
      link: 'https://www.youtube-nocookie.com/embed/jnr96aSlnn8',
    },
    {
      title: 'APP_TOUR.COMPLAINT.TITLE',
      body: 'APP_TOUR.COMPLAINT.BODY',
      link: 'https://www.youtube-nocookie.com/embed/4q0RYlXD6eg',
    },
    {
      title: 'APP_TOUR.NOTIFICATION.TITLE',
      body: 'APP_TOUR.NOTIFICATION.BODY',
      link: 'https://www.youtube-nocookie.com/embed/uodh4tDWnIw',
    }
  ];

  title: string;
  last_page_title: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private util: UtilService,
    private translate: TranslateService,
    private socialSharing: SocialSharing,
    private toast: ToastProvider) {

 this.dispapp = {dispAppName : "isocietymanager"}
 console.log(this.dispapp)

    let title = this.navParams.get("title");
    console.log(title);
    let last_page_title = this.navParams.get("last_page_title");
    this.title = (title) ? title : translate.instant("MENU_PAGES.HOW_IT_WORKS.TITLE");
    console.log(this.title);
    console.log(last_page_title)
    this.last_page_title = (last_page_title) ? last_page_title : translate.instant("GO_TO_DASHBOARD")
  }

  view(item) {
    this.util.openWithInAppBrowser(item.link);
  }

  share(item) {
    let msg = item.title + "\n\n" + item.link;
    console.log(msg);
    this.socialSharing.share(msg).then(() => {
      console.log("sharing done");
    }).catch(() => {
      this.toast.presentToast("Unable to share!");
    });
  }

  setSkip(){
    console.log("setSkip")
    localStorage.setItem('skip_tutorial','true' );  
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad HowItWorksPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/how-it-works/how-it-works.ts